import { render, staticRenderFns } from "./SuperAdminAccounts.vue?vue&type=template&id=8891fe50&scoped=true&"
import script from "./SuperAdminAccounts.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminAccounts.vue?vue&type=style&index=0&id=8891fe50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8891fe50",
  null
  
)

export default component.exports